module.exports = function() {
  return new Worker(__webpack_public_path__ + "3c18a00322474e2409d8.worker.js");
};